// Propriedades do menu
export interface IMenuProps {
    id: string;
    text: string;
    path: string;
    icon: string;
    group: string;
}

//Estrutura básica do menu. Com menu e submenu
interface IAppMenu {
    [mainMenu: string]: {
        id: string;
        text: string;
        path: string;
        icon: string;
        subMenu: {
            [subKey: string]: IMenuProps;
        };
    };
}

//Criação dos submenus. Todo submenu deve ter uma configuração aqui.
//Essa configuração deve ser a mesma do menu.ts
const companies: IMenuProps = {
    id: 'companies',
    text: 'Empresas',
    path: 'registers/companies',
    icon: 'Store',
    group: 'registers',
};

const costCenters: IMenuProps = {
    id: 'costCenters',
    text: 'Centros de Custo',
    path: 'registers/costCenters',
    icon: 'AttachMoney',
    group: 'registers',
};

const jobTitles: IMenuProps = {
    id: 'jobTitles',
    text: 'Funções',
    path: 'registers/jobTitles',
    icon: 'Work',
    group: 'registers',
};

const workResources: IMenuProps = {
    id: 'workResources',
    text: 'Ferramentas e EPI',
    path: 'registers/workResources',
    icon: 'Build',
    group: 'registers',
};

const employees: IMenuProps = {
    id: 'employees',
    text: 'Colaboradores',
    path: 'registers/employees',
    icon: 'PeopleAlt',
    group: 'registers',
};

const trainings: IMenuProps = {
    id: 'trainings',
    text: 'Treinamentos',
    path: 'registers/trainings',
    icon: 'School',
    group: 'registers',
};

const surveys: IMenuProps = {
    id: 'surveys',
    text: 'Questionários',
    path: 'registers/surveys',
    icon: 'Feed',
    group: 'registers',
};

const permissions: IMenuProps = {
    id: 'permissions',
    text: 'Permissões',
    path: 'registers/permissions',
    icon: 'Lock',
    group: 'registers',
};

const answeredSurveys: IMenuProps = {
    id: 'surveys',
    text: 'Questionários',
    path: 'operation/surveys',
    icon: 'Feed',
    group: 'operation',
};

const expiringWorkResources: IMenuProps = {
    id: 'expiringWorkResources',
    text: 'Venc. Ferramentas e EPI',
    path: 'operation/expiringWorkResources',
    icon: 'CalendarToday',
    group: 'operation',
};

const customers: IMenuProps = {
    id: 'customers',
    text: 'Clientes',
    path: 'registers/customers',
    icon: 'AccountCircle',
    group: 'registers',
};

const services: IMenuProps = {
    id: 'services',
    text: 'Serviços',
    path: 'registers/services',
    icon: 'DesignServices',
    group: 'registers',
};

const workOrders: IMenuProps = {
    id: 'workOrders',
    text: 'Ordens de Serviço',
    path: 'operation/workOrders',
    icon: 'InsertDriveFile',
    group: 'operation',
};

//Acessar as configurações do menu por uma chave. Essa chave deve ser a mesma cadastrada no banco de dados na tabela Screen
const MENUS: { [key: string]: IMenuProps } = {
    COMPANIES: companies,
    COST_CENTERS: costCenters,
    JOB_TITLES: jobTitles,
    WORK_RESOURCES: workResources,
    EMPLOYEES: employees,
    PERMISSIONS: permissions,
    TRAININGS: trainings,
    SURVEYS: surveys,
    ANSWERED_SURVEYS: answeredSurveys,
    EXPIRING_WORK_RESOURCES: expiringWorkResources,
    CUSTOMERS: customers,
    SERVICES: services,
    WORK_ORDERS: workOrders
};

//Configuração dos menus pai
const MENU_GROUPS: Record<string, Omit<IAppMenu[string], 'subMenu'>> = {
    registers: {
        id: 'registers',
        text: 'Cadastros',
        path: 'registers',
        icon: 'LibraryAdd',
    },
    operation: {
        id: 'operation',
        text: 'Operação',
        path: 'operation',
        icon: 'Grain',
    },
};

export function buildAppMenu(allowedKeys: string[]): IAppMenu {
    const groupedSubMenus: Record<string, Record<string, IMenuProps>> = {};

    for (const key of allowedKeys) {
        const menu = MENUS[key];
        if (menu) {
            const group = menu.group;
            if (!groupedSubMenus[group]) {
                groupedSubMenus[group] = {};
            }
            groupedSubMenus[group][menu.id] = menu;
        }
    }

    const appMenu: IAppMenu = {};

    for (const groupKey in groupedSubMenus) {
        const subMenuItems = groupedSubMenus[groupKey];
        const groupInfo = MENU_GROUPS[groupKey];
        if (groupInfo && Object.keys(subMenuItems).length > 0) {
            appMenu[groupKey] = {
                ...groupInfo,
                subMenu: subMenuItems,
            };
        }
    }

    return appMenu;
}
